import React from "react";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import { addVotes } from "../../Sevices/api-requests";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  card: {
    [theme.breakpoints.down("xs")]: {
      //height: "30vh",
      maxWidth: "70%",
      //marginLeft:"10%"
    },
    [theme.breakpoints.up("md")]: {
      //height: "35vh",
      maxWidth: "60%",
      // marginRight:"2%"
    },
  },
  media: {
    height: 280,
  },
}));

export default function VoteCard({
  name = "Adesokan Emmanuel",
  category,
  image = "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Muhammadu_Buhari%2C_President_of_the_Federal_Republic_of_Nigeria_%28cropped3%29.jpg/1200px-Muhammadu_Buhari%2C_President_of_the_Federal_Republic_of_Nigeria_%28cropped3%29.jpg",
  position = "senator",
  userId,
  disabled = () => console.log("hi"),
  reload,
  level,
}) {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState({});
  const classes = useStyles();

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    setMessage({});
    if (reason === "clickaway") {
      return;
    }
  };

  const handleYesVote = () => {
    setMessage({});
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(`Kindly confirm that you are voting "Yes" for ${name}`)
    ) {
      addVotes(userId, category, level, position, name, 1)
        .then((result) => {
          setMessage({
            error: false,
            message: result.data.data,
          });
          reload();
        })
        .catch((error) => {
          console.log(error.response.data.message);
          setMessage({
            error: true,
            message: error.response.data.message,
          });
        });
    }
  };

  const handleNoVote = () => {
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(`Kindly confirm that you are voting "No" for ${name}`)
    ) {
      setMessage({});
      addVotes(userId, category, level, position, name, 2)
        .then((result) => {
          setMessage({
            error: false,
            message: result.data.data,
          });
          reload();
        })
        .catch((error) => {
          setMessage({
            error: true,
            message: error.response.data.message,
          });
        });
    }
  };

  return (
    <Grid
      item
      xs={12}
      md={4}
      style={{ marginBottom: "10%", marginLeft: "15%" }}
    >
      <div className={classes.root}>
        <Snackbar
          open={Object.keys(message).length != 0}
          autoHideDuration={1000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={message.error ? "error" : "success"}
          >
            {message.message}
          </Alert>
        </Snackbar>
      </div>
      <Card className={classes.card}>
        <CardActionArea>
          <CardMedia className={classes.media} image={image} title={position} />
          <CardContent>
            <Typography gutterBottom>{name}</Typography>
            <Typography variant="h5" color="textSecondary" component="h2">
              {position}
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button
            size="small"
            disabled={true}
            onClick={handleYesVote}
            variant="contained"
            color="primary"
          >
            <b>Yes</b>
          </Button>
          <Button
            size="small"
            disabled={true}
            onClick={handleNoVote}
            variant="contained"
            color="primary"
          >
            <b>No</b>
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
}
